export default [
    {
        path: '/user/:id',
        name: 'user',
        component: () => import('@/views/user.vue')
    }
]